<template>
	<component
		ref="field_ref"
		v-on="fieldListeners"
		v-bind="defaultBindData"
		class="widget-field-wrapper text-left"
		:is="fieldConf.widgetFieldComponent"
		:field="field"
		:editMode="editMode"
		:fieldValue="fieldValue"
		:narrowLayout="narrowLayout"
		:previousSteps="previousSteps"
		:replaceInsertDataStringDict="replaceInsertDataStringDict"
		:configurationsMappingBlocksUUIDs="configurationsMappingBlocksUUIDs"
		:defaultValue="defaultValue"
	/>
</template>

<script>
import widgetFieldTypes from '../BlockEditorWidget/widgetFieldTypes';
import WidgetFieldService from '@/components/BlockEditorWidget/WidgetFieldService';

export default {
	name: 'WidgetFieldWrapper',
	props: {
		field: { type: Object },
		editMode: { type: Boolean },
		isFirstElement: { type: Boolean },
		testResponse: { type: Object },
		testResponseNotFlattened: { type: Object },
		narrowLayout: { type: Boolean },
		replaceInsertDataStringDict: { type: Object },
		configurationsMappingBlocksUUIDs: { type: Array },
		previousSteps: { type: Object, default: () => ({}) },
		fieldValue: {
			type: [Object, String, Boolean, Number, Array],
			default() {
				const key = `values.${this.field.id}`;
				return (
					this.testResponse?.[key] ??
					this.testResponseNotFlattened?.[key] ??
					WidgetFieldService.getDefaultValueOfField(
						this.field,
						this.previousSteps,
						this.replaceInsertDataStringDict,
						this.configurationsMappingBlocksUUIDs
					)
				);
			},
		},
	},
	methods: {
		invokeFieldsMethod(methodName) {
			return this.$refs.field_ref?.[methodName]?.();
		},
	},
	computed: {
		defaultValue() {
			return WidgetFieldService.getDefaultValueOfField(
				this.field,
				this.previousSteps,
				this.replaceInsertDataStringDict,
				this.configurationsMappingBlocksUUIDs
			);
		},
		fieldOptions() {
			return this.field.metadata.options || {};
		},
		titleData() {
			return this.fieldOptions.title || {};
		},
		descriptionData() {
			return this.fieldOptions.description || {};
		},
		defaultBindData() {
			return {
				field: this.field,
				titleValue: this.titleData.value,
				titleEnabled: this.titleData.enabled,
				descriptionValue: this.descriptionData.value,
				descriptionEnabled: this.descriptionData.enabled,
				...this.$attrs,
			};
		},
		fieldConf() {
			return widgetFieldTypes[this.field.field_type];
		},
		fieldListeners() {
			const eventToBeThrown = [
				'update-value',
				'update-value-label',
				'field-event',
				'on-mini-app-cancel',
				'on-mini-app-finished',
				'onCloseWidget',
				'restartRun',
				'applyInterfaceSubmit',
				'disable-cancel-button',
			];
			return eventToBeThrown.reduce((res, e) => ({ ...res, [e]: (v) => this.$emit(e, v) }), {});
		},
		fieldType() {
			return this.field.field_type;
		},
		isComplexValue() {
			return WidgetFieldService.isMultipleSelection(this.field);
		},
	},
	updated() {
		this.$emit('widgetFieldUpdated');
	},
	mounted() {
		if (this.isFirstElement) {
			this.$nextTick(() => {
				setTimeout(() => {
					this.invokeFieldsMethod('focus');
				}, 100);
			});
		}
	},
};
</script>

<style scoped lang="scss">
@import './widget-field-mixins.scss';

.widget-field-wrapper {
	::v-deep(.widget-input-field) {
		@include widget-input-field-overrides();
	}

	// fix for all Select Carets
	::v-deep(.v-icon) {
		&.fa-caret-down::before {
			content: '\f078' !important;
			font-size: 14px;
		}
	}
}
</style>
